export class EnumType {
    constructor(
        public id?: string,
        public value?: string,
        public description?: string,
    ) {

    }

}